<template>
  <div class="exc-info-block">
    <info-icon class="exc-info-block__icon" />
    <div class="exc-info-block__text" v-text="content" />
  </div>
</template>

<script>
export default {
  name: 'ExcInfoBlock',

  components: {
    InfoIcon: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/icons/errors/NotificationIcon.svg?inline'
      ),
  },

  props: {
    content: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="scss" scoped>
.exc-info-block {
  display: flex;
  align-items: center;
  font-size: toRem(14px);
  gap: toRem(8px);
  color: color(main);
  border-radius: toRem(12px);
  padding: toRem(8px);
  background: color('transp-04');

  &__icon {
    width: toRem(24px);
    height: toRem(24px);
    fill: currentColor;
    flex-shrink: 0;
  }
}
</style>
